module.exports = __webpack_public_path__ + "img/footer-background-small.b48bafc8.webp";